import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DataTable } from '@shopify/polaris';
import { ta } from '@utils';

const propTypes = {
  immutableList: PropTypes.object.isRequired,
  onRequest: PropTypes.func.isRequired,
};


// const OrderSupplyRequestTable = (props) => (
//       <DataTable 
//         columnContentTypes={[
//           'text','text','text','text','text', 'text', 'text'
//         ]}
//         headings={[
//           ta("variant.image") ,
//           ta("variant.vendor"), 
//           ta("variant.product_name"), 
//           ta("variant.variant_title"), 
//           ta("variant.sku"), 
//           ta("variant.quantity"), 
//           ta("variant.order_number")
//         ]}
//         verticalAlign="middle"
//         rows={ props.immutableList &&
//           props.immutableList.entrySeq().map( ([vendorKey, value]) => (
//             value.lineItems.map( li => [

//             ] 
//             [
//               <img src={li.imageSrc} height="90" />,
//               li.vendor,
//               li.name,
//               li.variantTitle,
//               li.sku,
//               li.quantity,
//               li.orderNumber
//             ]
//           ))
//         }
//       />
//         <tbody>
//           { props.items &&
//             props.items.entrySeq().map( ([vendorKey, value]) => (
//               <React.Fragment key={vendorKey}>
//                 <tr>
//                   <td className="vendorHeader" colSpan={7}>
//                     <div className="flex justifyBetween alignItemsCenter">
//                       <span>{vendorKey}</span>
//                       <Button 
//                         disabled={ value.requested }
//                         onClick={ () => props.onRequest(vendorKey) } >
//                         { value.requested ? I18n.t("app.requested") : I18n.t("app.request") }
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//                 { value.lineItems.map( (li) => (
//                   <tr key={li.id}>
//                     <td>
//                       <img src={li.imageSrc} height="160" />
//                     </td>
//                     <td>{ li.vendor }</td>
//                     <td>{ li.name }</td>
//                     <td>{ li.variantTitle }</td>
//                     <td>{ li.sku }</td>
//                     <td>{ li.quantity }</td>
//                     <td>{ li.orderNumber }</td>
//                   </tr>
//                 ))}
//               </React.Fragment>
//             ))  
//           }
// )

OrderSupplyRequestTable.propTypes = propTypes;


export default OrderSupplyRequestTable;
